import * as tslib_1 from "tslib";
import { SentimentColors } from "../../../constants";
import React, { PureComponent } from 'react';
import { getItem } from '../../../utils/card-value';
import { SunSvg } from '../../SvgIcons';
import "./IconViewChart.css";
import IconViewChartSvg from './IconViewChartSvg';

var IconViewChart =
/** @class */
function (_super) {
  tslib_1.__extends(IconViewChart, _super);

  function IconViewChart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  IconViewChart.prototype.render = function () {
    var _a = this.props,
        min = _a.min,
        max = _a.max,
        value = _a.value;
    var color = getItem(SentimentColors, value, min, max);
    return React.createElement("div", null, color !== undefined ? React.createElement(IconViewChartSvg, {
      color: color
    }) : React.createElement(SunSvg, null));
  };

  return IconViewChart;
}(PureComponent);

export default IconViewChart;